const pad = (n: number) => n.toString().padStart(2, '0');
const stamp = (d: Date) =>
  `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}T${pad(d.getHours())}${pad(d.getMinutes())}00`;

/** Downloads a one-off calendar event for tomorrow at the current time. No push, no account. */
export function downloadReminder(title: string, seconds: number) {
  const start = new Date();
  start.setDate(start.getDate() + 1);
  const minutes = Math.max(5, Math.round(seconds / 60));
  const now = new Date();
  const ics = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Daily Yoga Companion//EN',
    'BEGIN:VEVENT',
    `UID:${now.getTime()}@yoga.touchblack.in`,
    `DTSTAMP:${now.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '')}`,
    `DTSTART:${stamp(start)}`,
    `DURATION:PT${minutes}M`,
    `SUMMARY:Yoga: ${title}`,
    'DESCRIPTION:Time for your practice. Open https://yoga.touchblack.in/',
    'URL:https://yoga.touchblack.in/',
    'BEGIN:VALARM',
    'TRIGGER:-PT0M',
    'ACTION:DISPLAY',
    'DESCRIPTION:Time for your practice',
    'END:VALARM',
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n');

  const url = URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = 'daily-yoga-reminder.ics';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
